import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=094afb76&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094afb76')) {
      api.createRecord('094afb76', component.options)
    } else {
      api.reload('094afb76', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=094afb76&", function () {
      api.rerender('094afb76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21t6ySJ1Sh13S/JS/comp/IncreaseNumber.vue"
export default component.exports